<template lang="es">
    <v-container fluid>
        <!-- Listado de tipo de tratamientos -->
        <ComponenteCrud
            tipo="mantenimiento"
            :datos=tipos_tratamiento
            @editar="editar"
            @eliminar="eliminar"
            @nuevo="nuevo_formulario()"
        ></ComponenteCrud>
        <!-- Formulario para agregar un nuevo tipo de tratamiento -->
        <FormularioTipoTratamiento v-if="formulario_tipo_tratamiento"
        :modo="modo_tipo_tratamiento"
        :tipo_tratamientoEntrada= tipos_tratamiento.tipo_tratamiento_editando
        @close="submit_tipo_mantenimiento"
        @cancel="cancel"
        ></FormularioTipoTratamiento>

    </v-container>
</template>
<script>
import FormularioTipoTratamiento from '@/components/crud/formularios/FormularioTipoTratamiento.vue'

import ComponenteCrud from '@/components/modulos/ComponenteCrud.vue'
import { mapActions } from "vuex";

export default {
    components:{
        ComponenteCrud,FormularioTipoTratamiento
    },
    data() {
        return {
            tipos_tratamiento:{
                tipo_tratamiento_editando:{},
                nuevo:false,
                editando:false,
                headers:[
                    {text: "Id", value: "id"},
                    {text: "Nombre", value: "name", width: '80%'},
                    {text: "Acción", value: "action"},
                ],
                items:[]
            },
        }
    },

    computed: {
        modo_tipo_tratamiento(){return !this.tipos_tratamiento.nuevo?'editar':''},
        formulario_tipo_tratamiento(){
            return this.tipos_tratamiento.nuevo || this.tipos_tratamiento.editando
        }
    },

    methods: {
        ...mapActions('api',['getTiposTratamiento','postTipoTratamiento','putTipoTratamiento','deleteTipoTratamiento']),
        async get_tipos_tratamiento(){
            const response = await this.getTiposTratamiento();
            this.tipos_tratamiento.items=response.data;
            this.tipos_tratamiento.items.splice();
            console.log(response)
        },
        nuevo_formulario(){
            console.log("nuevo formlario")
            this.tipos_tratamiento.nuevo=true;
        },
        async submit_tipo_mantenimiento(payload){
            if (this.tipos_tratamiento.nuevo==true){
                console.log("Debo llamar al backend para hacer el post",payload)
                await this.postTipoTratamiento(payload)
                this.tipos_tratamiento.nuevo=false;
            }else{
                this.tipos_tratamiento.editando=false;
                this.tipos_tratamiento.tipo_tratamiento_editando={};

                await this.putTipoTratamiento(payload)
            }
            await this.get_tipos_tratamiento();
        },
        editar(item){
            console.log("quiere editar",item)
            this.tipos_tratamiento.editando=true;
            this.tipos_tratamiento.tipo_tratamiento_editando=item;
            //llama a la accion de abrir formulario pasandole como parametro el item que queremos editar
        },
        async eliminar(item){
            console.log("quiere eliminar",item)
            await this.deleteTipoTratamiento(item)
            await this.get_tipos_tratamiento();
            //llama a la accion de abrir formulario pasandole como parametro el item que queremos editar
        },
        cancel(){
            this.tipos_tratamiento.editando=false;
            this.tipos_tratamiento.nuevo=false;
        }

    },


    mounted() {
        this.get_tipos_tratamiento();
    },
}
</script>
<style lang="">
    
</style>